<template>
  <v-dialog v-model="propDialogo" width="500px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="clearFields(); $emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            {{ this.propNuevo ? "NUEVO" : "EDITAR" }} INSTRUCTOR
          </h1>
        </div>
        <div style="padding-left: 10px; padding-right: 10px; margin: 10px">
          <div>
          </div>
        </div>
        <div class="line" style="padding: 10px; margin: 10px; border-radius: 5px">
          <!-- -------------------- -->
          <div>
            <h2>Imagen (alto: 800px; ancho: 400px)</h2>
            <div style="width: 100%; margin-bottom: 10px;">
              <input type="file" ref="fileInput" @change="handleImageUpload" accept="image/*" style="display: none" />
              <v-btn color="blue" style="color: white;" block @click="$refs.fileInput.click()">Buscar Imagen</v-btn>
              <div v-if="imagePreview">
                <div
                  style="margin-top: 10px; width: 100%; height: 150px; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center;">
                  <img :src="imagePreview" alt="Vista previa" style="max-width: 100%; max-height: 100%;" />
                </div>
                <h3>Imagen nueva</h3>
              </div>
              <div v-if="imagePreviewOld" style="width: 100%; margin-bottom: 10px;">
                <div
                  style="margin-top: 10px; width: 100%; height: 150px; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center;">
                  <img :src="`${$env.pathImg}/${imagePreviewOld}`" alt="Vista previa"
                    style="max-width: 100%; max-height: 100%;" />
                </div>
                <h3>Imagen actual</h3>
              </div>
            </div>
            <div>
              <h2>Rol/Asignación</h2>
              <v-text-field v-model="formulario.rol" outlined dense placeholder="Ingrese título" />
            </div>
            <div>
              <h2>Nombres</h2>
              <v-text-field v-model="formulario.nombres" outlined dense placeholder="Ingrese título" />
            </div>
              <div>
              <h2>Titulo/Ultimos estudios</h2>
              <v-text-field v-model="formulario.titulo" outlined dense placeholder="Ingrese título" />
            </div>
            <div>
              <h2>Mensaje</h2>
              <v-textarea v-model="formulario.mensaje" placeholder="Ingrese contenido" outlined no-resize />
            </div>
          
              <div>
              <h2>Enlace a CV</h2>
              <v-text-field v-model="formulario.enlacecv" outlined dense placeholder="Ingrese título" />
            </div>
            <v-btn block color="#0D47A1" style="color: white" @click="propNuevo ? crearInstructor() : actualizarInstructor()">
              <h2>GUARDAR</h2>
            </v-btn>
          </div>
          <!-- -------------------- -->
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    propCrear: { type: Function },
    propActualizar: { type: Function },
    propNuevo: { type: Boolean },
    propDialogo: { type: Boolean },
    propInstructor: { type: Object }
  },
  data() {
    return {
      formulario: {
        id: '',
        rol: '',
        nombres: '',
        imagen: null,
        titulo: '',
        mensaje: '',
        enlacecv: '',
      },
      imagePreview: null,
      imagePreviewOld: null,
      sms: "",
    };
  },
  mounted() { },
  watch: {
    propInstructor() {
      this.clearFields()
      this.setFields()
    }
  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formulario.imagen = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },

    async crearInstructor() {
      if (!this.formulario.rol ||!this.formulario.nombres || !this.formulario.titulo ||!this.formulario.mensaje || !this.formulario.imagen) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("rol", this.formulario.rol);
      form.append("nombres", this.formulario.nombres);
      form.append("imagen", this.formulario.imagen);
      form.append("titulo", this.formulario.titulo);
      form.append("mensaje", this.formulario.mensaje);
      form.append("enlacecv", this.formulario.enlacecv);
      try {
        const result = await this.propCrear(form); // Enviamos como formulario
        const _result = result.data
        if (_result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    async actualizarInstructor() {
      if (!this.formulario.titulo || !this.formulario.nombres) {
        this.sms = "Faltan campos por llenar";
        return;
      }
      const form = new FormData();
      form.append("id", this.formulario.id);
      form.append("rol", this.formulario.rol);
      form.append("nombres", this.formulario.nombres);
      form.append("imagen", this.formulario.imagen);
      form.append("titulo", this.formulario.titulo);
      form.append("mensaje", this.formulario.mensaje);
      form.append("enlacecv", this.formulario.enlacecv);
      try {
        const result = await this.propActualizar(form); // Enviamos como formulario
        if (result.status === "success") {
          this.clearFields()
          this.$emit("closeDialogo");
        } else {
          this.sms = "Error al registrar. Intente nuevamente.";
        }
        
      } catch (error) {
        console.error(error);
        this.sms = "Error inesperado.";
      }
    },
    setFields() {
      this.formulario.id = this.propInstructor.id
      this.formulario.rol = this.propInstructor.rol
      this.formulario.nombres = this.propInstructor.nombres
      this.formulario.imagen = this.propInstructor.imagen_ruta
      this.formulario.titulo = this.propInstructor.titulo
      this.formulario.mensaje = this.propInstructor.mensaje
      this.formulario.enlacecv = this.propInstructor.enlacecv
      this.imagePreviewOld = this.propInstructor.imagen_ruta
    },
    clearFields() {
      this.formulario.rol = ''
      this.formulario.nombres = ''
      this.formulario.imagen = null
      this.formulario.id = ''
      this.formulario.titulo = ''
      this.formulario.mensaje = ''
      this.formulario.enlacecv = ''
      this.imagePreview = null
      this.imagePreviewOld = null
    },
    genDate() {
      const options = {
        timeZone: "America/Guayaquil", // Configura la zona horaria de Guayaquil
        hour12: false, // Usar formato de 24 horas
      };

      const now = new Date();

      // Usar toLocaleString para obtener la fecha en la zona horaria especificada
      const year = now.toLocaleString("es-EC", { ...options, year: "numeric" });
      const month = String(
        now.toLocaleString("es-EC", { ...options, month: "2-digit" })
      ).padStart(2, "0");
      const day = String(
        now.toLocaleString("es-EC", { ...options, day: "2-digit" })
      ).padStart(2, "0");
      const hours = String(
        now.toLocaleString("es-EC", { ...options, hour: "2-digit" })
      ).padStart(2, "0");
      const minutes = String(
        now.toLocaleString("es-EC", { ...options, minute: "2-digit" })
      ).padStart(2, "0");
      const seconds = String(
        now.toLocaleString("es-EC", { ...options, second: "2-digit" })
      ).padStart(2, "0");
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped></style>
